// @ts-nocheck

import React, { useCallback, useEffect, useMemo } from 'react';
import { Switch, Route } from 'react-router-dom';

import { Target } from '../../../../client';
import useRouter from '../../../../hooks/useRouter';
import { RoutePatterns } from '../../../../types/routes';
import GridsBasketViewContainer from '../../containers/basket/GridsBasketViewContainer';
import GridsHelpMatchContainer from '../../containers/GridsHelpMatchContainer';
import GridsTutoContainer from '../../containers/GridsTutoContainer';
import { isGridHelpOpen, isGridStatsOpen, isGridSystemDetailsOpen } from '../../utils/routes';
import PublicGridDetails from '../public/PublicGridDetails';

import GridModal from './GridModal';

const GridsModals = () => {
  const { history, location } = useRouter();
  const isBasketOpen = location.hash.indexOf('#cart') === 0;
  const matchId = location.state?.matchId;
  const gridReference = location.state?.gridReference;
  const isHelpOpen = isGridHelpOpen(location);
  const isStatsOpen = isGridStatsOpen(location);
  const isSystemDetailsOpen = isGridSystemDetailsOpen(location);
  const shouldCloseModal = useMemo(
    () => Target.__MOBILE__ && isSystemDetailsOpen && !gridReference,
    [gridReference, isSystemDetailsOpen],
  );

  const closeModal = useCallback(() => {
    if (location.hash) {
      history.push(location.pathname);
    } else {
      history.goBackOrReplace(location.pathname);
    }
  }, [history, location.hash, location.pathname]);

  useEffect(() => {
    if (shouldCloseModal) {
      closeModal();
    }
  }, [closeModal, shouldCloseModal]);

  return (
    <Switch>
      <Route
        path={RoutePatterns.GRIDS}
        render={() => (
          <GridModal
            closeModal={closeModal}
            isOpen={isBasketOpen || isHelpOpen || isStatsOpen || isSystemDetailsOpen}
            isDark={!isBasketOpen}
            toTheTop={isHelpOpen}
            centerContent={isHelpOpen}
          >
            {isBasketOpen ? (
              <Switch>
                <Route path={RoutePatterns.GRID_PUBLIC} component={GridsBasketViewContainer} exact />
                <Route path={RoutePatterns.GRID_HISTORY_DETAIL} component={GridsBasketViewContainer} exact />
                <Route component={GridsBasketViewContainer} />
              </Switch>
            ) : (
              <>
                {isStatsOpen && <GridsHelpMatchContainer matchId={matchId} />}
                {isSystemDetailsOpen && <PublicGridDetails gridReference={gridReference} />}
                {isHelpOpen && <GridsTutoContainer />}
              </>
            )}
          </GridModal>
        )}
      />
    </Switch>
  );
};

export default GridsModals;
